import { QwepContext } from '@f_qwep/context/Qwep_context';
import styles from '@f_qwep/styles/component/purchasingAssistant/PurchasingAssistant.module.sass';
import { Tariff } from '@f_qwep/types';
import { useContext } from 'react';
import { AssistantListsView } from './AssistantLists.view';
import { CreateListView } from './CreateList.view';
import { CurrentListActionsView } from './CurrentListActionsView';
import { WatchEducationVideoView } from './WatchEducationVideo.view';

export const ConfigPanelActionsView = () => {
    const { tariff } = useContext(QwepContext);

    return (
        <div className={styles.config}>
            <div className={styles.nav}>
                {tariff === Tariff.Business ? <CreateListView /> : null}
                <AssistantListsView />
                {tariff === Tariff.Business ? <CurrentListActionsView /> : null}
            </div>
            <WatchEducationVideoView />
        </div>
    );
};
